/**
 * Набор функцией, реализующих загрузку модулей системы, которые рекомендуется загружать в отложенном режиме
 *
 * Функции выполняют загрузку в память полный код модулей и компонентов
 */
export default class {

	/**
	 * Загрузить в память полный функционал TopNotice
	 */
	static async TopNotice() {
		// Core.flags.needLoadNotice = true;
		await import('@/components/core/notice/notice.vue');
	}

	/**
	 * Загрузить в память полный функционал TopPopup
	 */
	static async TopPopup() {
		await import('@/components/popup/lib/popup');
	}

	/**
	 * Загрузить в память полный функционал TopDialog
	 */
	static async TopDialog() {
		const { TopDialogWorker } = await import('@/core/app');
		await TopDialogWorker.getDialogsUtils();
	}

};
